<script>
export default {
    name: "NHIFPatientReport",
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>NHIF Visit Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">NHIF Visit Report</h5>
        </template>
        <template v-slot:card-body>
            <div class="flex flex-wrap">
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-search" class="label-control">Search:</label>
                    <input type="text" id="grid-search" class="input-control input-sm text-xs">
                </div>
                <div class="md:w-1/5 sm:w-full p-1 pt-4">
                    <button class="btn-sm btn-info text-xs rounded"><i class="fa fa-filter"></i> Filter</button>
                </div>
            </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/12">MRN</th>
                            <th class="p-tiny w-1/6">Names</th>
                            <th class="p-tiny w-1/12">OPFileNo</th>
                            <th class="p-tiny w-1/12">IPFileNo</th>
                            <th class="p-tiny w-1/12">ID NO</th>
                            <th class="p-tiny w-1/12">Member No</th>
                            <th class="p-tiny w-1/12">Visit Date</th>
                            <th class="p-tiny w-1/12">Patient Status</th>
                            <th class="p-tiny w-1/12">Phone</th>
                            <th class="p-tiny w-1/12">NHIF STATUS</th>
                            <th class="p-tiny w-1/12">CHOICE OF FACILITY</th>
                        </tr>
                  </thead>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:70vh;">
                      <tr class="w-full flex">
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/6"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                          <td class="p-tiny w-1/12"></td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>